import React from 'react';
import { Swords } from 'lucide-react';

interface RushStartScreenProps {
  onStart: () => void;
  onBattle?: () => void;
  isLoading: boolean;
  isBattleLoading?: boolean;
  error: string | null;
}

export const RushStartScreen: React.FC<RushStartScreenProps> = ({ onStart, onBattle, isLoading, isBattleLoading, error }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] px-6 text-center">
      <h1
        className="text-4xl sm:text-5xl font-bold tracking-tight mb-3 animate-fade-up opacity-0"
        style={{ color: 'hsl(var(--foreground))', fontFamily: 'DM Serif Display, serif' }}
      >
        TRIVIA RUSH
      </h1>
      <p
        className="text-base sm:text-lg mb-10 max-w-xs animate-fade-up-delay opacity-0"
        style={{ color: 'hsl(var(--muted-foreground))' }}
      >
        Which company has the higher metric? Answer fast, one wrong and it's over!
      </p>

      <div className="animate-fade-up-delay-2 opacity-0 flex flex-col gap-3">
        <button
          onClick={onStart}
          disabled={isLoading || isBattleLoading}
          className="px-10 py-4 rounded-full text-lg font-bold transition-all duration-200 disabled:opacity-50 hover:scale-105 active:scale-95"
          style={{
            backgroundColor: 'var(--rush-purple-mid)',
            color: '#fff',
            boxShadow: 'var(--rush-shadow-glow)',
          }}
        >
          {isLoading ? 'LOADING...' : (
            <span className="flex items-center justify-center gap-2">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="6,3 20,12 6,21" />
              </svg>
              START RUSH
            </span>
          )}
        </button>

        {onBattle && (
          <button
            onClick={onBattle}
            disabled={isLoading || isBattleLoading}
            className="flex items-center justify-center gap-2 px-10 py-3.5 rounded-full text-base font-bold transition-all duration-200 disabled:opacity-50 hover:scale-105 active:scale-95"
            style={{
              backgroundColor: 'rgba(139, 92, 246, 0.15)',
              color: 'hsl(var(--foreground))',
              border: '1px solid rgba(139, 92, 246, 0.3)',
            }}
          >
            <Swords className="w-5 h-5" />
            {isBattleLoading ? 'CREATING...' : 'BATTLE'}
          </button>
        )}
      </div>

      {error && (
        <p className="mt-4 text-sm" style={{ color: 'var(--rush-wrong)' }}>
          {error}
        </p>
      )}
    </div>
  );
};
